import { createApp } from 'vue'
import appComponent from './App.vue'
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isoWeek from "dayjs/plugin/isoWeek";

const app = createApp(appComponent)

// Register VUEX store
import { kcStore } from './store.js'
app.use(kcStore)

// Register dayjs
import 'dayjs/locale/de'
dayjs.locale('de')
dayjs.extend(duration)
dayjs.extend(isoWeek);
app.config.globalProperties.$dayjs = dayjs;

// Register VUETIFY
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import vuetify from './plugins/vuetify.js'
app.use(vuetify)

// Benutzerdefinierte CSS-Stylesheets
import './styles/kitchen-companion.scss';

// Global components
import registerComponents from './components/global-components.js';
registerComponents(app);

// App mount
let instance = app.mount('#app');